import React from 'react'
import StatsCard from '../../UI/staticsCard'
import { StatsProductShowConfig } from '../../../pages/stores/product/show/config';
import { useQuery } from 'react-query';
import { getProductStats } from '../../../MyApi/product/stats';

const StatsProductCard = ({id}) => {
    console.log('id', id)
    const {data,isLoading}=useQuery( "getProductStats",()=>getProductStats(id) )
    const productStats =data?.data.stats ||{}
      const statsProduct = StatsProductShowConfig(productStats);
  return (
   <div className="card rounded-3">
          <div className="card-body">
            <h4 className="font16 mb-2">الإحصائيات</h4>
            {statsProduct.map((stats ,i) => (
              <StatsCard {...stats} key={i} />
            ))}
          </div>
        </div>
  )
}

export default StatsProductCard